import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { HTML } from '@adornis/cms/db/scalars.js';

// TODO: move all remaining functionality into new Setting Class
@Entity()
export class GlobalSetting extends MongoEntity {
  static override _class = 'GlobalSetting';
  static override _collectionName = 'global-setting';

  // Legal docs have been moved to separate InstitutionLegalDoc entities
  // Query them directly using InstitutionLegalDoc.getOrCreate() when needed

  @Field(type => HTML, { default: v => v ?? new HTML() }) maintenanceModeRender!: string;

  @Field(type => Date) lastSendNewsletter: Maybe<Date>;
  @Field(type => Date) lastSendNewWorkshopDocumentsMails: Maybe<Date>;

  @Field(type => ID)
  logoID?: Maybe<string>;

  @Field(type => ID)
  emailBannerImageID: Maybe<string>;

  @Field(type => ID)
  multiCertTemplateID?: Maybe<string>;

  @Field(type => ID)
  multiCertTemplateID_en?: Maybe<string>;
}
